
/* eslint-disable */
import BASE from '../../../../vue.config.js'
const $ = require('jquery')
import 'prismjs'
import 'prismjs/themes/prism.css'
import Vue from 'vue/dist/vue.js'
import listado from '../../../assets/js/ScriptListadoGeneral.js'

export default {
	data() {
		return {
			pagos: [],
			del: false,
			idPago: '',
			pagina: "reportePagos",
			permisoEliminar: 0,
			permisoConsultar: 0
		}
	},
	methods: {
		getPagos() {

			fetch(`${this.$BASE.baseUrl}api/ListadoPagos/1`, {
				method: 'GET',
				headers: {
					'Authorization': sessionStorage.getItem('token'),
					'pagina': 'planteles',
					'paginaOrigen': 'listadoPlanteles'
				}
			})
				.then(rs => rs.json())
				.catch(error => console.log('error:', error))
				.then(rs => {
					if (rs.status == 200) {
						this.pagos = rs.result.pagos;
						rs.result.permisos.forEach((item, indx) => {
							if (item.id == 4) { this.permisoEliminar = 1; }
							if (item.id == 5) { this.permisoConsultar = 1; }
						});
					}
					console.log(JSON.stringify(this.pagos));
				});
		},

		EliminarRgistro() {
			listado.methods.EliminarRegistro(this.idPago, this.pagina);
			this.del = false;
		},


		validatePaymentStatus(status) {
			switch (status) {
				case 1:
					return {
						color: 'warning',
						text: 'En Revisión'
					}
					break;
				case 2:
					return {
						color: 'success',
						text: 'Aceptado'
					}
					break;
				case 3:
					return {
						color: 'danger',
						text: 'Rechazado'
					}
					break;
				default:
					console.log('Payment Status Error')
					break;
			}
		},
		switchPaymentStatus(payment, idDetalle) {
			// var css = '*{cursor:wait !important;}';
			// var style = document.createElement('style');
			// style.type = 'text/css';
			// style.id = 'cursor-waiting';
			// style.appendChild(document.createTextNode(css));
			// document.head.appendChild(style);

			document.body.style.cursor = 'wait';
			console.log(payment.idPago)
			fetch(`${this.$BASE.baseUrl}api/ValidarPagos/${payment.idPago}/${idDetalle}`, {
				method: 'GET',
				headers: {
					'Authorization': sessionStorage.getItem('token'),
					'pagina': 'validarPagos',
				}
			})
				.then(rs => rs.json())
				.catch(error => console.log('error:', error))
				.then(rs => {
					console.log(JSON.stringify(rs));
					if (rs.status == 200) {
						this.getPagos();
					}
					document.body.style.cursor = 'default';
				});
		},
		downloadFile(pagoUrl) {
			this.$_downloadFileMixin_donwloadFile(pagoUrl)
		}
	},

	created() {
		this.getPagos()
	}
}